import { InterventionPatternType } from 'services/src/models';
import * as Yup from 'yup';

export const InterventionPatternValidationSchema = () =>
	Yup.object().shape({
		patternName: Yup.string()
			.required('Nazwa wzorca jest wymagana!')
			.max(1000, `Nazwa wzorca może mieć maksymalnie 1000 znaków`),
		patternType: Yup.string().required('Typ wzorca jest wymagany!'),
		interventionAreaDictionaryValueId: Yup.number()
			.nullable()
			.test(
				'intervention-area-test',
				'Zasięg interwencji jest wymagany!',
				function (value: number) {
					const isAotmit =
						this.parent['patternType'] &&
						this.parent['patternType'] ==
							InterventionPatternType.AOTMITRECOMENDATION;
					if (isAotmit) return true;

					return value != undefined;
				}
			),
		interventionAreaDictionaryOtherValue: Yup.string().nullable(),
		name: Yup.string()
			.nullable()
			.test(
				'intervention-name-test',
				'Nazwa interwencji jest wymagana!',
				function (value: string) {
					const isAotmit =
						this.parent['patternType'] &&
						this.parent['patternType'] ==
							InterventionPatternType.AOTMITRECOMENDATION;
					if (isAotmit) return true;

					return value != undefined;
				}
			)
			.transform((value: string, originalValue: string) =>
				originalValue.trim() === '' ? null : value
			)
			.max(1000, `Nazwa inwerwencji może mieć maksymalnie 1000 znaków`)
			.test(
				'no-sklonow-word',
				({ value }) => {
					if (!value) return true;
					const match = value.match(/\b(sklonow\w*)\b/gi);
					if (match) {
						return `Usuń słowo: ${match[0]}`;
					}
					return undefined;
				},
				function (value) {
					if (!value) return true;
					const match = value.match(/\b(sklonow\w*)\b/gi);
					return !match;
				}
			),
		isCompliantWithRecommendation: Yup.boolean()
			.nullable(true)
			.test(
				'isCompliantWithRecommendation-test-aotmit',
				'Pole jest wymagane',
				function (value: boolean | undefined) {
					switch (
						this.parent.patternType as InterventionPatternType
					) {
						case InterventionPatternType.AOTMITRECOMENDATION:
							return value!;

						default:
							return true;
					}
				}
			),
	});
